import { Sites } from '@ps/platform-message-framework/common/Sites';
import { ResolverTag } from '@ps/web-core-enums';
import type { TranslationTag } from '@ps/web-core-intl';
import type { IspSportsAlias } from '@ps/web-sports-config';
import type { FormattedMessage } from 'react-intl';

import type {
  PlaceBetLegFailureCode,
  PlaceBetRespCode,
  PlaceBetResultCode,
  PlaceBetRunnerFailureCode
} from '@swf/sports/types/place-bet';

import {
  TXTACL_You_can_still_make_withdrawals_ELL,
  TXTCLI_For_more_informationX_please_v_ELL_2,
  TXTCLI_We_are_unable_to_confirm_your__ELL,
  TXTCLI_Your_status_is_currently_inact_ELL,
  TXTSRV_Please_wait_while_we_verify_yo_ELL,
  TXTWCL_A_deposit_limit_must_be_set_be_ELL,
  TXTWCL_A_problem_occurred_updating_yo_ELL,
  TXTWCL_After_you_switch_from_Poker_or_ELL,
  TXTWCL_Bet_Placement_failedX,
  TXTWCL_Bet_Placement_failedX_Acca_Ins_ELL,
  TXTWCL_Bet_Placement_failedX_Market_n_ELL,
  TXTWCL_Bet_Placement_failedX_One_or_m_ELL,
  TXTWCL_Bet_Placement_failedX_Please_v_ELL,
  TXTWCL_Bet_Placement_failedX_Price_no_ELL,
  TXTWCL_Bet_Placement_failedX_Promotio_ELL,
  TXTWCL_Bet_Placement_failedX_Promotio_ELL_1,
  TXTWCL_Bet_Placement_failedX_Selectio_ELL,
  TXTWCL_Bet_Placement_failedX_Selectio_ELL_1,
  TXTWCL_Bet_Placement_failedX_SorryX_w_ELL_1,
  TXTWCL_Bet_Placement_failedX_We_are_e_ELL,
  TXTWCL_Bet_placement_failedX_Due_to_i_ELL,
  TXTWCL_Bet_placement_failed_as_the_be_ELL_1,
  TXTWCL_Bet_placement_operation_finish_ELL,
  TXTWCL_Bet_placement_rejected_due_to__ELL,
  TXTWCL_Due_to_local_regulations_you_m_ELL,
  TXTWCL_Minimum_stake_is_N0,
  TXTWCL_Please_complete_registration_b_ELL,
  TXTWCL_Selection_not_available_In_pla_ELL,
  TXTWCL_Selection_not_foundX,
  TXTWCL_Something_went_wrongX_please_c_ELL,
  TXTWCL_Something_went_wrongX_please_t_ELL,
  TXTWCL_SorryX_we_could_not_place_your_ELL,
  TXTWCL_SorryX_we_couldnXt_place_your__ELL,
  TXTWCL_SorryX_we_have_been_unable_to__ELL_10,
  TXTWCL_SorryX_we_have_been_unable_to__ELL_11,
  TXTWCL_SorryX_we_have_been_unable_to__ELL_12,
  TXTWCL_SorryX_we_have_been_unable_to__ELL_9,
  TXTWCL_SorryX_you_donXt_have_the_fund_ELL,
  TXTWCL_SorryX_your_bet_stake_is_too_h_ELL,
  TXTWCL_Stake_must_be_a_multiple_of_N0,
  TXTWCL_The_username_youXve_requested__ELL,
  TXTWCL_WeXve_temporarily_restricted_y_ELL,
  TXTWCL_XstrongXChange_from_Play_Money_ELL_1,
  TXTWCL_You_are_attempting_to_place_be_ELL,
  TXTWCL_You_are_currently_active_on_an_ELL,
  TXTWCL_You_are_currently_not_register_ELL,
  TXTWCL_You_are_currently_set_to_use_P_ELL,
  TXTWCL_You_are_currently_within_the_5_ELL,
  TXTWCL_You_canXt_use_two_of_our_produ_ELL,
  TXTWCL_You_may_be_attempting_to_acces_ELL,
  TXTWCL_Your_account_has_been_closedX__ELL,
  TXTWCL_Your_account_has_been_suspende_ELL_3,
  TXTWCL_Your_account_is_Pending_Author_ELL,
  TXTWCL_Your_account_privileges_have_b_ELL,
  TXTWCL_Your_betXsX_can_not_be_placed__ELL,
  TXTWCL_Your_betXsX_cannot_be_placed_b_ELL,
  TXTWCL_Your_bet_cannot_be_placed_as_y_ELL,
  TXTWCL_Your_bet_cannot_be_placed_as_y_ELL_1,
  TXTWCL_Your_bet_cannot_be_placed_as_y_ELL_2,
  TXTWCL_Your_bet_cannot_be_placed_as_y_ELL_3,
  TXTWCL_Your_bet_cannot_be_placed_as_y_ELL_4,
  TXTWCL_Your_bet_cannot_be_placed_as_y_ELL_5,
  TXTWCL_Your_bet_cannot_be_placed_as_y_ELL_6,
  TXTWCL_Your_bet_was_not_placed_as_cur_ELL,
  TXTWCL_Your_potential_payout_exceeds__ELL_1
} from './bet-slip-errors.messages.json';

const customBetSlipErrorCodes = [
  'AML_USER_SUSPENDED',
  'BET_SLIP_UPDATE_FAILED',
  'NETWORK_FAILURE',
  'EXCEPTION',
  'GENERAL_FAILURE',
  'PLAY_MONEY_NOT_SUPPORTED',
  'USER_SUSPENDED_BY_REGULATOR'
] as const;
export type CustomBetSlipErrorCode = (typeof customBetSlipErrorCodes)[number];
export const isCustomBetSlipErrorCode = (errCode: string): errCode is CustomBetSlipErrorCode =>
  (customBetSlipErrorCodes as readonly string[]).includes(errCode);

type SpbBetSlipErrorCode = PlaceBetRespCode;
export type BetSlipErrorCode = CustomBetSlipErrorCode | SpbBetSlipErrorCode;

interface AliasLink {
  alias: IspSportsAlias;
  params?: React.ComponentProps<typeof FormattedMessage>['values'];
}

interface ResolverTagLink {
  resolverTag: ResolverTag;
}

export const isResolverTagLink = (link: AliasLink | ResolverTagLink): link is ResolverTagLink =>
  'resolverTag' in link;

export interface ComplexBetSlipErrorConfig {
  titleTranslationTag?: TranslationTag;
  contentTranslationTag: TranslationTag;
  footerTranslationTag?: TranslationTag;

  /**
   * Denotes whether the error will automatically dismiss after a period of time
   * @default true
   */
  isAutoDismissible?: false;

  siteOverrides?: {
    [key in Sites]?: Omit<ComplexBetSlipErrorConfig, 'siteOverrides'>;
  };

  link?: AliasLink | ResolverTagLink;
  variant?: AlertVariant;
  level?: AlertLevel;
  isCollapsible?: boolean;
}

export type AlertVariant = 'passive' | 'passive-aggressive' | 'aggressive';
export type AlertLevel = 'success' | 'update' | 'warning' | 'destructive' | 'promotion';
export type SimpleBetSlipErrorConfig = TranslationTag;
export type BetSlipErrorConfig = SimpleBetSlipErrorConfig | ComplexBetSlipErrorConfig;

export type BetLevelErrorCode =
  | PlaceBetResultCode
  | PlaceBetRunnerFailureCode
  | PlaceBetLegFailureCode;

export type BetLevelErrorMessage = Partial<Record<BetLevelErrorCode, BetSlipErrorConfig>>;

const resultCodeMappings = {
  AML_USER_SUSPENDED: TXTWCL_Bet_Placement_failedX,
  BET_PLACEMENT_RUNNER_FAILURE: TXTWCL_SorryX_we_couldnXt_place_your__ELL,
  GENERAL_FAILURE: {
    contentTranslationTag: TXTWCL_Something_went_wrongX_please_c_ELL,
    link: {
      alias: 'sportsMyBets',
      params: { status: 'open' }
    }
  },
  INSUFFICIENT_FUNDS: TXTWCL_SorryX_you_donXt_have_the_fund_ELL,
  OVER_LOSS_LIMIT: TXTWCL_SorryX_we_could_not_place_your_ELL,
  OTHER_FAILURE_IN_REQUEST: TXTWCL_SorryX_we_couldnXt_place_your__ELL,
  STAKE_BELOW_MINIMUM_ALLOWED: TXTWCL_Minimum_stake_is_N0,
  STAKE_ABOVE_MAXIMUM_ALLOWED: TXTWCL_SorryX_your_bet_stake_is_too_h_ELL,
  CUST_REGISTRATION_PENDING: TXTWCL_Please_complete_registration_b_ELL,
  INVALID_BET_TYPE: TXTWCL_SorryX_we_couldnXt_place_your__ELL,
  INVALID_LEG_TYPE: TXTWCL_SorryX_we_couldnXt_place_your__ELL,
  DUPLICATE_BET: {
    contentTranslationTag: TXTWCL_Something_went_wrongX_please_c_ELL,
    link: {
      alias: 'sportsMyBets',
      params: { status: 'open' }
    }
  },
  STARTING_PRICE_NOT_AVAILABLE: TXTWCL_SorryX_we_couldnXt_place_your__ELL,
  LIVE_PRICE_NOT_AVAILABLE: TXTWCL_SorryX_we_couldnXt_place_your__ELL,
  PROMOTION_CANNOT_BE_USED: TXTWCL_Bet_Placement_failedX_Promotio_ELL_1,
  PROMOTION_NOT_COMBINABLE: TXTWCL_Bet_Placement_failedX_Promotio_ELL,
  INSUFFICIENT_LIVE_FUNDS: TXTWCL_Your_bet_was_not_placed_as_cur_ELL,
  EACHWAY_NOT_AVAILABLE: TXTWCL_SorryX_we_couldnXt_place_your__ELL,
  ACCA_INSURANCE_NOT_AVAILABLE: TXTWCL_Bet_Placement_failedX_Acca_Ins_ELL,
  MULTIPLE_PRICE_NOT_AVAILABLE: TXTWCL_Bet_Placement_failedX_Price_no_ELL,
  GUARANTEED_PRICE_NOT_AVAILABLE: TXTWCL_SorryX_we_couldnXt_place_your__ELL,
  STAKE_INCREMENT_INVALID: TXTWCL_Stake_must_be_a_multiple_of_N0,
  INVALID_BET_COMBINATION: TXTWCL_Bet_Placement_failedX_One_or_m_ELL,
  INSUFFICIENT_VALID_FUNDS_FOR_INPLAY: TXTWCL_Bet_Placement_failedX,
  SELF_EXCLUSION: TXTWCL_Bet_placement_rejected_due_to__ELL,
  REQUESTED_EACHWAY_PLACES_NOT_AVAILABLE: TXTWCL_SorryX_we_couldnXt_place_your__ELL,
  EDGE_TERMS_NOT_AVAILABLE: TXTWCL_SorryX_we_couldnXt_place_your__ELL,
  WALLET_AMOUNTS_CONSTRAINT_ERROR: TXTWCL_SorryX_we_couldnXt_place_your__ELL,
  PAYOUT_ABOVE_MAXIMUM_ALLOWED: TXTWCL_Your_potential_payout_exceeds__ELL_1,
  LINES_ABOVE_MAXIMUM_ALLOWED: TXTWCL_SorryX_we_couldnXt_place_your__ELL,
  INVALID_BET_DEFINITION: TXTWCL_SorryX_we_couldnXt_place_your__ELL,
  PRICE_BOOST_TOKEN_NOT_AVAILABLE: TXTWCL_Bet_placement_failedX_Due_to_i_ELL,
  WALLET_EXPIRED: TXTWCL_Bet_Placement_failedX_SorryX_w_ELL_1,
  REGULATOR_REJECTED: TXTWCL_Bet_placement_failed_as_the_be_ELL_1,
  HISTORICAL_BALANCE_EXCEEDED: TXTWCL_Your_betXsX_cannot_be_placed_b_ELL,
  ACCOUNT_CREATED_AFTER_EVENT_START: TXTWCL_Your_betXsX_can_not_be_placed__ELL,
  BLOCKGAMEPLAY_PARALLELVERTICAL: {
    contentTranslationTag: TXTWCL_You_canXt_use_two_of_our_produ_ELL,
    link: { resolverTag: ResolverTag.HelpResponsibleGaming }
  },
  BLOCKGAMEPLAY_TIMELIMIT: {
    contentTranslationTag: TXTWCL_After_you_switch_from_Poker_or_ELL,
    link: { resolverTag: ResolverTag.HelpResponsibleGaming }
  },
  FAILED_GEO_COMPLY_PENDING: {
    contentTranslationTag: TXTWCL_SorryX_we_couldnXt_place_your__ELL,
    siteOverrides: {
      [Sites.CA_ON]: {
        contentTranslationTag: TXTSRV_Please_wait_while_we_verify_yo_ELL
      }
    }
  },
  FAILED_GEO_COMPLY_REJECTED: {
    contentTranslationTag: TXTWCL_SorryX_we_couldnXt_place_your__ELL,
    siteOverrides: {
      [Sites.CA_ON]: {
        titleTranslationTag: TXTCLI_We_are_unable_to_confirm_your__ELL,
        contentTranslationTag: TXTWCL_SorryX_we_have_been_unable_to__ELL_10,
        isAutoDismissible: false,
        link: { resolverTag: ResolverTag.HelpCenter }
      }
    }
  },
  FAILED_GEO_COMPLY_SOFTWARE_BLOCKED: {
    contentTranslationTag: TXTWCL_SorryX_we_couldnXt_place_your__ELL,
    siteOverrides: {
      [Sites.CA_ON]: {
        titleTranslationTag: TXTCLI_We_are_unable_to_confirm_your__ELL,
        contentTranslationTag: TXTWCL_SorryX_we_have_been_unable_to__ELL_9,
        isAutoDismissible: false,
        link: { resolverTag: ResolverTag.HelpCenter }
      }
    }
  },
  FAILED_GEO_COMPLY_UNKNOWN: {
    contentTranslationTag: TXTWCL_SorryX_we_couldnXt_place_your__ELL,
    siteOverrides: {
      [Sites.CA_ON]: {
        titleTranslationTag: TXTCLI_We_are_unable_to_confirm_your__ELL,
        contentTranslationTag: TXTWCL_SorryX_we_have_been_unable_to__ELL_11,
        isAutoDismissible: false,
        link: { resolverTag: ResolverTag.HelpCenter }
      }
    }
  },
  FAILED_GEO_COMPLY_USING_PROXY: {
    contentTranslationTag: TXTWCL_SorryX_we_couldnXt_place_your__ELL,
    siteOverrides: {
      [Sites.CA_ON]: {
        titleTranslationTag: TXTCLI_We_are_unable_to_confirm_your__ELL,
        contentTranslationTag: TXTWCL_SorryX_we_have_been_unable_to__ELL_12,
        isAutoDismissible: false,
        link: { resolverTag: ResolverTag.HelpCenter }
      }
    }
  },
  DAILY_SPEND_LIMIT_CONSUMED: {
    contentTranslationTag: TXTWCL_Your_bet_cannot_be_placed_as_y_ELL_6,
    isAutoDismissible: false
  },
  DAILY_LOSS_LIMIT_CONSUMED: {
    contentTranslationTag: TXTWCL_Your_bet_cannot_be_placed_as_y_ELL_2,
    isAutoDismissible: false
  },
  MONTHLY_SPEND_LIMIT_CONSUMED: {
    contentTranslationTag: TXTWCL_Your_bet_cannot_be_placed_as_y_ELL_4,
    isAutoDismissible: false
  },
  MONTHLY_LOSS_LIMIT_CONSUMED: {
    contentTranslationTag: TXTWCL_Your_bet_cannot_be_placed_as_y_ELL_1,
    isAutoDismissible: false
  },
  WEEKLY_LOSS_LIMIT_CONSUMED: {
    contentTranslationTag: TXTWCL_Your_bet_cannot_be_placed_as_y_ELL,
    isAutoDismissible: false
  },
  REGULATOR_ACTIVE_ELSEWHERE: {
    contentTranslationTag: TXTWCL_You_are_currently_active_on_an_ELL,
    isAutoDismissible: false
  },
  REGULATOR_DUPLICATE_PLAYER: {
    contentTranslationTag: TXTWCL_The_username_youXve_requested__ELL,
    isAutoDismissible: false
  },
  REGULATOR_FAILURE: {
    contentTranslationTag: TXTWCL_Something_went_wrongX_please_t_ELL,
    isAutoDismissible: false
  },
  REGULATOR_LIMIT_REQUIRED: {
    contentTranslationTag: TXTWCL_A_deposit_limit_must_be_set_be_ELL,
    isAutoDismissible: false
  },
  REGULATOR_LONG_SESSION_ACK: {
    contentTranslationTag: TXTWCL_Due_to_local_regulations_you_m_ELL,
    isAutoDismissible: false
  },
  REGULATOR_PLAYER_INACTIVE: {
    contentTranslationTag: TXTCLI_Your_status_is_currently_inact_ELL,
    isAutoDismissible: false
  },
  REGULATOR_PLAYER_NOT_REGISTERED: {
    contentTranslationTag: TXTWCL_You_are_currently_not_register_ELL,
    isAutoDismissible: false,
    link: { resolverTag: ResolverTag.HelpResponsibleGaming }
  },
  REGULATOR_PLAYER_WAITING_PERIOD: {
    contentTranslationTag: TXTWCL_You_are_currently_within_the_5_ELL,
    isAutoDismissible: false
  },
  RG_LIMITS_SETUP_REQUIRED: {
    contentTranslationTag: TXTWCL_Your_bet_cannot_be_placed_as_y_ELL_3,
    isAutoDismissible: false
  },
  SPENDING_LIMIT_CONSUMED: {
    contentTranslationTag: TXTWCL_Your_bet_cannot_be_placed_as_y_ELL_5,
    isAutoDismissible: false
  }
} as const satisfies Partial<Record<PlaceBetResultCode, BetSlipErrorConfig>>;

const runnerFailureCodeMappings = {
  INVALID_GLOBAL_MARKET_ID: TXTWCL_SorryX_we_couldnXt_place_your__ELL,
  INVALID_SELECTION_ID: TXTWCL_SorryX_we_couldnXt_place_your__ELL,
  BET_TYPE_NOT_SUPPORTED: TXTWCL_SorryX_we_couldnXt_place_your__ELL,
  MARKET_NOT_FOUND: TXTWCL_Bet_Placement_failedX_Market_n_ELL,
  SELECTION_NOT_FOUND: TXTWCL_Selection_not_foundX,
  SELECTION_NOT_AVAILABLE_INPLAY: TXTWCL_Selection_not_available_In_pla_ELL,
  MARKET_SUSPENDED: TXTWCL_Bet_Placement_failedX_Market_n_ELL,
  RUNNER_SUSPENDED: TXTWCL_Bet_Placement_failedX_Selectio_ELL_1,
  REQUESTED_PRICE_NOT_AVAILABLE: TXTWCL_Bet_Placement_failedX_Price_no_ELL,
  PREPLAY_EVENT_STARTED: TXTWCL_Bet_Placement_failedX_Market_n_ELL,
  REQUESTED_HANDICAP_NOT_AVAILABLE: TXTWCL_Bet_Placement_failedX_Market_n_ELL,
  INVALID_COMBINATION: TXTWCL_Bet_Placement_failedX_One_or_m_ELL,
  DUPLICATE_RUNNER: TXTWCL_SorryX_we_couldnXt_place_your__ELL,
  PRICE_BOOST_PRICE_NOT_AVAILABLE: TXTWCL_SorryX_we_couldnXt_place_your__ELL,
  EVENT_BLOCKED_FOR_USER_JURISDICTION: TXTWCL_Bet_Placement_failedX_Please_v_ELL
} as const satisfies Partial<Record<PlaceBetRunnerFailureCode, BetSlipErrorConfig>>;

const legFailureCodeMappings = {
  LEG_SUSPENDED: TXTWCL_Bet_Placement_failedX_Selectio_ELL_1,
  INVALID_BET_LEG: TXTWCL_Bet_Placement_failedX,
  DUPLICATE_LEG: TXTWCL_Bet_Placement_failedX_Selectio_ELL,
  LEG_TYPE_UNAVAILABLE: TXTWCL_Bet_Placement_failedX_Selectio_ELL_1
} as const satisfies Partial<Record<PlaceBetLegFailureCode, BetSlipErrorConfig>>;

const placeBetRespCodeMappings = {
  ACCOUNT_CLOSED: {
    contentTranslationTag: TXTWCL_Your_account_has_been_closedX__ELL,
    isAutoDismissible: false
  },
  ACCESS_DENIED: TXTWCL_Bet_Placement_failedX,
  ACCOUNT_DUPLICATE_CARDS: TXTWCL_Your_account_has_been_suspende_ELL_3,
  ACCOUNT_LOCKED: {
    contentTranslationTag: TXTWCL_Your_account_has_been_suspende_ELL_3,
    isAutoDismissible: false
  },
  ACCOUNT_PENDING_AUTH: {
    contentTranslationTag: TXTWCL_Your_account_is_Pending_Author_ELL,
    isAutoDismissible: false
  },
  ACCOUNT_SUSPENDED: {
    contentTranslationTag: TXTWCL_Your_account_has_been_suspende_ELL_3,
    isAutoDismissible: false
  },
  ACCOUNT_SECURITY_QUESTION_WRONG_3_TIMES: {
    contentTranslationTag: TXTWCL_Your_account_has_been_suspende_ELL_3,
    isAutoDismissible: false
  },
  ACCOUNT_SUSPENDED_KYC: {
    contentTranslationTag: TXTWCL_Your_account_has_been_suspende_ELL_3,
    isAutoDismissible: false
  },
  INVALID_COUNTRY: TXTWCL_You_may_be_attempting_to_acces_ELL,
  INVALID_PROTECTION_STATUS: TXTWCL_You_are_attempting_to_place_be_ELL,
  PARTIAL_SUCCESS: TXTWCL_Bet_placement_operation_finish_ELL,
  REGULATOR_CLOSED: TXTWCL_Bet_Placement_failedX_Please_v_ELL
} as const satisfies Partial<Record<PlaceBetRespCode, BetSlipErrorConfig>>;

const customErrorCodeMappings = {
  AML_USER_SUSPENDED: TXTWCL_WeXve_temporarily_restricted_y_ELL,
  BET_SLIP_UPDATE_FAILED: TXTWCL_A_problem_occurred_updating_yo_ELL,
  NETWORK_FAILURE: {
    contentTranslationTag: TXTWCL_Something_went_wrongX_please_c_ELL,
    link: {
      alias: 'sportsMyBets',
      params: { status: 'open' }
    }
  },
  EXCEPTION: {
    contentTranslationTag: TXTWCL_Bet_Placement_failedX_We_are_e_ELL,
    siteOverrides: {
      [Sites.ITA]: {
        contentTranslationTag: TXTWCL_Something_went_wrongX_please_c_ELL,
        link: {
          alias: 'sportsMyBets',
          params: { status: 'open' }
        }
      }
    }
  },
  GENERAL_FAILURE: {
    contentTranslationTag: TXTWCL_Something_went_wrongX_please_c_ELL,
    link: {
      alias: 'sportsMyBets',
      params: { status: 'open' }
    }
  },
  PLAY_MONEY_NOT_SUPPORTED: {
    titleTranslationTag: TXTWCL_XstrongXChange_from_Play_Money_ELL_1,
    contentTranslationTag: TXTWCL_You_are_currently_set_to_use_P_ELL,
    isAutoDismissible: false,
    level: 'warning',
    variant: 'passive',
    isCollapsible: false
  },
  USER_SUSPENDED_BY_REGULATOR: {
    titleTranslationTag: TXTWCL_Your_account_privileges_have_b_ELL,
    contentTranslationTag: TXTACL_You_can_still_make_withdrawals_ELL,
    footerTranslationTag: TXTCLI_For_more_informationX_please_v_ELL_2,
    isAutoDismissible: false,
    link: { resolverTag: ResolverTag.HelpCenter }
  }
} as const satisfies Record<CustomBetSlipErrorCode, BetSlipErrorConfig>;

export const betLevelErrorMapping: BetLevelErrorMessage = {
  ...resultCodeMappings,
  ...runnerFailureCodeMappings,
  ...legFailureCodeMappings
};

export const defaultBetLevelErrorConfig: ComplexBetSlipErrorConfig = {
  contentTranslationTag: TXTWCL_SorryX_we_couldnXt_place_your__ELL
} as const;

export const betSlipErrorMapping: Partial<
  Record<PlaceBetRespCode | CustomBetSlipErrorCode, BetSlipErrorConfig>
> = {
  ...placeBetRespCodeMappings,
  ...customErrorCodeMappings
};

export const defaultBetSlipErrorConfig: ComplexBetSlipErrorConfig = {
  contentTranslationTag: TXTWCL_Bet_Placement_failedX
} as const;
